import { LogService } from './log.service';
import { PermissionAccess } from 'globals/store/permissions.data';
import { tap, takeUntil, first, take, lastValueFrom } from 'rxjs';
import { UserService } from './user.service';
import { Store, select } from '@ngrx/store';
import { PermissionAccessTypes, permissionsActions, permissionsFeature } from '../store/permissions.era';
import { inject, Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { OnReset, Transitions } from './transition.service.helpers';
import { EVENT_PERMISSIONS, PAGE_INFO, PAGE_NAME, convertOldPermissions, AccessTypeKeys, AccessType } from '../../../globals/store/permissions.data';
import { Router } from '@angular/router';
import { doc, docSnapshots, Firestore, onSnapshot, setDoc } from '@angular/fire/firestore';
export { PAGE_NAME, EVENT_PERMISSIONS, PAGE_INFO }

@Injectable({ providedIn: 'root' })
export class EventPermissionsService implements OnReset {

  db = inject(Firestore)

  readonly _file:string = 'event.permissions.service.ts';
  public readonly: {[key: string]: boolean} = {}
  public access = {}
  public types = []
  private _uid
  private _eventId
  triedToSelfCorrect = false
  justGotPermissions = false
  $destroy:Subject<boolean> = new Subject()

  onReset(resetType, value = null) {
    switch (resetType) {
      case Transitions.OnEnterUser:
        this._uid = value.uid
        break;
      case Transitions.OnExitUser:
        this._uid = null
        this.triedToSelfCorrect = false
        return this.$destroy.next(true)
      case Transitions.OnEnterEvent:
        this._eventId = value.eventId
        // console.log("Event id loaded in event permissions service", this._eventId)
        if (!this._uid) throw new Error ('Missing uid in event permissions service for some inexplicable reason')
        this.loadPermissions(this._uid)
        return
      case Transitions.OnExitEvent:
        this.reset()
        return
      default:
        break
    }
  }

  reset() {
    this.triedToSelfCorrect = false
    this.$destroy.next(true)
  }

  constructor(public store: Store, private userService:UserService, private log:LogService, private router: Router){
    this.store.pipe(select(permissionsFeature.selectReadonly)).subscribe(readonly=>{
      this.readonly = readonly.reduce((obj,item)=>{
        obj[item] = true;
        return obj
      },{})
    })
    this.store.pipe(select(permissionsFeature.selectAll)).subscribe(all=>{
      this.access = all.reduce((obj,item)=>{
        obj[item] = true;
        return obj
      },{})
    })
  }

  getBlankRestrictionsObject(types?: AccessType[]):PermissionAccess {
    const restrictions:PermissionAccess = {
      types: types || [],
      restrictor:this.userService.uid
    };
    return restrictions;
  }

  async getRestrictionsFor(uid_or_email:string, eventId: string = null): Promise<PermissionAccess>{
    if (!eventId) eventId = this._eventId
    const permissions = (await lastValueFrom(docSnapshots(doc(this.db, 'events/'+eventId+'/restrictions/'+uid_or_email)).pipe(take(1)))).data();
    if (!permissions) {
      console.log(`Could not get permissions for ${uid_or_email} on event ${eventId}.  Perhaps it is a new user?  Resolving blank permissions object`)
      return this.getBlankRestrictionsObject()
    }
    return convertOldPermissions(permissions)
  }

  async loadPermissions(uid) {
    onSnapshot(doc(this.db, 'events/'+ this._eventId+'/restrictions/'+uid), (doc) => {
      if (doc.exists()) {
        let access: PermissionAccess = doc.data() as PermissionAccess
        if (!access) access = { types:[PermissionAccessTypes.supervisor], restrictor:uid } 
        // console.log({ access })

        this.types = access.types;
        this.store.dispatch(permissionsActions.loadPermissions(access))
      }
    }, async (response)=>{
      this.log.error({file:this._file, function:'loadPermissions',response,error:new Error()})
    })
  }
          

  async saveRestrictionsFor(uid_or_email:string, permissions:PermissionAccess){
    permissions.restrictor = this.userService.uid;
    await setDoc(doc(this.db, 'events/'+this._eventId+'/restrictions/'+uid_or_email), permissions)
    this.store.dispatch(permissionsActions.addEventWidePermissionsForSingleUser(uid_or_email, permissions.types))
  }
}
